import React, { useState } from "react";
import imageAlejandria from "../../components/assets/Alejandria-Logo.png";
import FirstQuestionComponent from "./firstQuestion";
import SecondQuestionComponent from "./secondQuestion";
import ThirdQuestionComponent from "./thirdQuestion";
import FourthQuestionComponent from "./fourthquestion";
import FourthQuestionFormComponent from "../formAppointment/fourthQuestion";
import OldPatientComponent from "./oldPatient";
import {
  getAvailableDates,
  validateNewPatientAndGetData,
  newAppointment,
} from "../../api/api";
import "./styles.css";
import gif from "../../components/assets/j.gif";
import ModalComponent from "./modalConfirm";
import ModalFinalResponseComponent from "./modalFinalResponse";

const AppointmentComponent = () => {
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [responseAvailableDates, setResponseAvailableDates] = useState({});
  const [responseValidationAndGetData, setResponseValidationAndGetData] =
    useState({});
  const [appointmentSelected, setAppointmentSelected] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const [finalResponse, setFinalResponse] = useState();
  const [reasonSelected, setReasonSelected] = useState({});
  const [showModalFinalResponse, setShowModalFinalResponse] = useState(false);
  const [modalConfirmAppointemnt, setModalConfirmAppointemnt] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [boolConfirmAppointment, setBoolConfirmAppointment] = useState(false);
  const [infoPatient, setInfoPatient] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    nif: "",
  });
  const [appointment, setAppointment] = useState({
    idCl: "",
    idDrList: "-1",
    idDr: "",
    idMo: "",
    idEs: "",
    ct_fpre: "",
    ct_hpre: "",
    duration: 0,
    observations: "",
    clientWeb: true,
  });

  const buttonClick = (questionNumber) => {
    setCurrentQuestion(questionNumber);
    setAppointmentSelected(null);
    setReasonSelected(null);
  };

  const questionResponse = (response) => {
    setCurrentQuestion(response);
    setAppointmentSelected(null);
  };

  const openModalInfoPatientAndAppointment = () => {
    setModalConfirmAppointemnt(true);
  };

  const closeModalInfoPatientAndAppointment = () => {
    setModalConfirmAppointemnt(false);
  };

  const openModalFinalResponse = () => {
    setShowModalFinalResponse(true);
  };

  const closeModalFinalResponse = () => {
    setShowModalFinalResponse(false);
  };

  const onChangeInfoPatient = (updatedValue) => {
    setInfoPatient((prevInfo) => ({
      ...prevInfo,
      name: updatedValue.name,
      phoneNumber: updatedValue.phoneNumber,
      email: updatedValue.email,
      nif: updatedValue.nif,
    }));
  };

  const modalityAndSpecialtySelected = (reason, codeSpeciality) => {
    setReasonSelected(reason);
    const newIdsModalityAndReason = {
      ...appointment,
      idMo: reason.id,
      idEs: codeSpeciality,
      duration: reason.duration,
    };
    setAppointment(newIdsModalityAndReason);

    callApiDates(newIdsModalityAndReason);
    questionResponse(4);
  };

  const appointmentSelectedByClickOnCard = (appointment) => {
    const hour = appointment.hour.split(" - ")[0];
    setAppointment((prevInfo) => ({
      ...prevInfo,
      idDr: appointment.doctor.id,
      ct_fpre: appointment.date,
      ct_hpre: hour,
    }));
  };

  const callApiValidator = () => {
    setIsLoading(true);
    validateNewPatientAndGetData(
      infoPatient,
      onResponseValidatePatient,
      onError
    );
  };

  const callApiDates = (newIdsModalityAndReason) => {
    setIsLoading(true);
    getAvailableDates(
      infoPatient,
      onResponse,
      onError,
      newIdsModalityAndReason
    );
  };

  const callApiConfirmAppointment = () => {
    setIsLoadingModal(true);
    newAppointment(infoPatient, appointment, onResponseConfirm, onError);
  };

  const onResponseValidatePatient = (response) => {
    const responseParse = JSON.parse(response);
    if (!responseParse.error) {
      setIsLoading(false);
      setResponseValidationAndGetData(responseParse);
      questionResponse(3);
    } else if (responseParse.error.message) {
      setErrorMessage(responseParse.error.message);
      setShowErrorModal(true);
      setIsLoading(false);
    }
  };

  const onResponse = (response) => {
    setIsLoading(false);
    setResponseAvailableDates(JSON.parse(response));
  };

  const onResponseConfirm = (response) => {
    const responseOnConfirm = JSON.parse(response);
    if (responseOnConfirm.message) {
      // Éxito: redirigir inmediatamente sin actualizar estado
      window.location.href = "https://clinicaalejandria.es/cita-confirmada/";
    } else {
      // Error: mostrar modal con mensaje de error
      setBoolConfirmAppointment(false);
      setFinalResponse(responseOnConfirm);
      setIsLoadingModal(false);
      closeModalInfoPatientAndAppointment();
      openModalFinalResponse();
    }
  };

  const onError = (error) => {
    setIsLoading(false);
    console.log("Error", error);
    window.location.href = "https://clinicaalejandria.es/";
  };

  const onClickModalError = () => {
    setShowErrorModal(false);
    setCurrentQuestion(5);
  };

  const onClickBtnFinalModal = () => {
    closeModalFinalResponse();
    callApiDates(appointment);
  };

  const renderCurrentQuestion = () => {
    switch (currentQuestion) {
      case 1:
        return <FirstQuestionComponent questionResponse={questionResponse} />;
      case 2:
        return (
          <SecondQuestionComponent
            onChangeInfoPatient={onChangeInfoPatient}
            callApiValidator={callApiValidator}
            infoPatient={infoPatient}
            setInfoPatient={setInfoPatient}
          />
        );
      case 3:
        return (
          <ThirdQuestionComponent
            modalityAndSpecialtySelected={modalityAndSpecialtySelected}
            responseValidationAndGetData={responseValidationAndGetData}
          />
        );
      case 4:
        return responseAvailableDates ? (
          <FourthQuestionComponent
            responseAvailableDates={responseAvailableDates}
            setAppointmentSelected={setAppointmentSelected}
            appointmentSelected={appointmentSelected}
            openModalInfoPatientAndAppointment={
              openModalInfoPatientAndAppointment
            }
            appointmentSelectedByClickOnCard={appointmentSelectedByClickOnCard}
            reasonSelected={reasonSelected}
          />
        ) : null;
      default:
        return null;
    }
  };

  return (
    <div className="appointmentContainer">
      <img className="imageAlejandria" src={imageAlejandria} />
      {currentQuestion === 5 ? (
        <OldPatientComponent setCurrentQuestion={setCurrentQuestion} />
      ) : (
        <div className="newAppointmentNewPatient">
          <div className="appointmentButtons">
            <button className="buttonOption" onClick={() => buttonClick(1)}>
              1
            </button>
            <div
              className={`lineButtons ${currentQuestion >= 2 ? "active" : ""}`}
              style={currentQuestion >= 2 ? { background: "#676563" } : null}
            />
            <button
              className="buttonOption"
              onClick={() => buttonClick(2)}
              disabled={currentQuestion !== 2 && currentQuestion <= 2}
            >
              2
            </button>
            <div
              className={`lineButtons ${currentQuestion >= 3 ? "active" : ""}`}
              style={currentQuestion >= 3 ? { background: "#676563" } : null}
            />
            <button
              className="buttonOption"
              onClick={() => buttonClick(3)}
              disabled={currentQuestion !== 3 && currentQuestion <= 3}
            >
              3
            </button>
            <div
              className={`lineButtons ${currentQuestion >= 4 ? "active" : ""}`}
              style={currentQuestion >= 4 ? { background: "#676563" } : null}
            />
            <button
              className="buttonOption"
              onClick={() => buttonClick(4)}
              disabled={currentQuestion !== 4 && currentQuestion <= 4}
            >
              4
            </button>
          </div>
          {isLoading ? (
            <div className="loadingContainer">
              <img src={gif} alt="Loading" className="loadingGif" />
            </div>
          ) : (
            renderCurrentQuestion()
          )}
        </div>
      )}
      {modalConfirmAppointemnt && (
        <ModalComponent
          appointmentSelected={appointmentSelected}
          closeModalInfoPatientAndAppointment={
            closeModalInfoPatientAndAppointment
          }
          callApiConfirmAppointment={callApiConfirmAppointment}
          setAppointment={setAppointment}
          appointment={appointment}
          isLoadingModal={isLoadingModal}
        />
      )}
      {showModalFinalResponse && (
        <ModalFinalResponseComponent
          finalResponse={finalResponse}
          closeModalFinalResponse={closeModalFinalResponse}
          boolConfirmAppointment={boolConfirmAppointment}
          onClickBtnFinalModal={onClickBtnFinalModal}
        />
      )}
      {showErrorModal && (
        <div className="errorModal">
          <div className="errorModalContent">
            <h2 className="titleErrorModal">Upps!!</h2>
            <p className="contentErrorModal">{errorMessage}</p>
            <button className="btnErrorModal" onClick={onClickModalError}>
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppointmentComponent;
